export interface SimpleLookup {
  Label: string;
  Id: number;
};
